import { Injectable } from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { Platform } from '@ionic/angular';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root'
})
export class SplashScreenService {
  constructor(
    private platform: Platform,
    private configService: ConfigService
  ) {}

  async init() {
    // Load settings first
    await this.configService.loadConfig();

    // Update splash screen content with settings
    const titleElement = document.querySelector('#app-splash h1');
    const infoElement = document.querySelector('#app-splash p');
    
    if (titleElement) {
      titleElement.textContent = this.configService.getAppName();
    }
    if (infoElement) {
      infoElement.textContent = this.configService.getAppDescription();
    }

    // Hide splash screen on mobile platforms
    if (this.platform.is('capacitor')) {
      await SplashScreen.hide();
    }
  }

  show() {
    const splash = document.querySelector('#app-splash');
    if (splash) {
      splash.classList.remove('hide');
    }
  }

  hide() {
    const splash = document.querySelector('#app-splash');
    if (splash) {
      splash.classList.add('hide');
    }
  }
}
